/**
 * @generated SignedSource<<f5d3ffd341bbe8ab32808f1df0472471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectState = "ACTIVE" | "ARCHIVED" | "%future added value";
export type ReactivateProjectInput = {
  id: string;
};
export type ReactivateProjectDialogMutation$variables = {
  input: ReactivateProjectInput;
};
export type ReactivateProjectDialogMutation$data = {
  readonly reactivateProject: {
    readonly id: string;
    readonly state: ProjectState;
  };
};
export type ReactivateProjectDialogMutation = {
  response: ReactivateProjectDialogMutation$data;
  variables: ReactivateProjectDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "reactivateProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReactivateProjectDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactivateProjectDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "903ab2342ced68f27ebe936aa8ecf3bb",
    "id": null,
    "metadata": {},
    "name": "ReactivateProjectDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ReactivateProjectDialogMutation(\n  $input: ReactivateProjectInput!\n) {\n  reactivateProject(input: $input) {\n    id\n    state\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ac49ffb19a9edecbd38d94505c0ea08";

export default node;
